import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Button, Typography} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress';
import {styled} from '@mui/material/styles';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import Divider from '@mui/material/Divider';
import RadialChart from "./RadialChart";
import * as util from "../utils/util";
import api from "../utils/api";

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetWeight = {
  weight: 0
}

const HistoryWeightInputCard = (props: any) => {
  const navigate = useNavigate();
  const [dayValue, setDayValue] = useState(0);
  const [targetWeight, setTargetWeight] = React.useState(initTargetWeight);
  
  useEffect(() => {
    setWeightData();
  }, []);

  function setWeightData() {
    // 체중 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_018?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetWeight(res.data.result_data.target);
      }
    }).catch(function (error) {
      console.log(error)
    });
  }
    
  function getTitleForTargetWeight(targetWeight :any) {
    if(targetWeight.weight > 0){
      return '오늘 체중 입력 완료!';
    }else {
      return '오늘 체중을 입력하지 않으셨습니다.';
    }
  }
  
  function getBorderProgressValue(targetWeight :any) {
    return targetWeight.weight > 0 ? 100 : 0;
  }
  
  

  return (
    <Box alignItems="stretch" sx={Card_Style} >

      <Typography sx={{ textAlign: 'center', fontSize: 14, fontWeight: 700, p: '15px 0 15px 0' }}>오늘 체중 기록</Typography>
      <Divider />
      <Box sx={{ p: 0.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Stack justifyContent={'center'} alignItems={'center'} sx={{ flexGrow: 1 }}>
          {/* 방사형 게이지 하단 여백만큼 끌어올려 수치와의 간격을 줄임 */}
          <Box sx={{ mb: '-16px' }}>
            <RadialChart value={targetWeight.weight} />
          </Box>

          <Button onClick={() => {navigate('../history/HistoryWeight')}} sx={{ flexWrap: 'wrap', p: 0 }}>
            <Stack direction={'row'} alignItems={'baseline'}>
              <Typography sx={{ color: '#555', fontSize: 22, pr: '5px', fontWeight: 700 }}>{targetWeight.weight}</Typography>
              <Typography sx={{ color: '#888', fontSize: 14, textTransform: 'none' }}>kg</Typography>
            </Stack>
          </Button>

          <Box sx={{ pt: 0.5, pb: 2 }}>
            <Button onClick={() => {navigate('../history/HistoryWeight')}} sx={{ p: 0, border: '1px solid #EF8322', borderRadius: 5 }}>
              <EditNoteRoundedIcon sx={{ ml: 1, color: '#EF8322' }} />
              <Typography sx={{ color: '#EF8322', fontSize: 14, pr: 1, fontWeight: 700, pl: .5 }}>입력하기</Typography>
            </Button>
          </Box>
        </Stack>
        <Divider />
        <Box sx={{ p: 0.5, }}>
          <Typography sx={{ fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 32, color: '#555' }}> {getTitleForTargetWeight(targetWeight)}</Typography>
        </Box>
      </Box>

      <BorderLinearProgress variant="determinate" value={getBorderProgressValue(targetWeight)}
        sx={{ borderRadius: '0 0 20px 20px', bgcolor: '#eaeaea' }}
      />
    </Box>
  );
  {/* <ListItem alignItems="flex-start" sx={Card_Style} >
          <ListItemAvatar>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
          </ListItemAvatar>
          <ListItemText
          primary ={title} 
          secondary={
              <Box>
                  <Box>{props.values.kcal} {props.values.unitType} 
                      <Button onClick={props.values.navi}>
                          <ModeIcon />
                      </Button>
                  </Box>
                  {props.values.emptyText}
                  <LinearProgress variant="determinate" value={progress} />
              </Box>
          }
          >
          </ListItemText>
      </ListItem> 
  );*/}
}

const BorderLinearProgress = styled(LinearProgress)({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#eaeaea',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#7fd36b',
  },
});

const Card_Style = {
  borderRadius: '10px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',

  flex: '0 50%',
  maxWidth: '100%',

  // 옆 카드와 높이를 맞추기 위해 세로 flex 로 구성 (하단 진행바는 항상 카드 맨 아래)
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column'
};

export default HistoryWeightInputCard;